import { useEffect } from 'react';
import { useTheme } from '@gripp/shared-logic';

/**
 * Keeps the `dark` class on `<html>` in step with the resolved theme.
 *
 * The class is set for the *first* paint by the inline bootstrap in
 * `public/index.html`; this only handles changes after the bundle loads —
 * the user toggling Appearance, or the OS flipping while the preference is
 * `system`. Both must be handled here because the bootstrap runs once.
 *
 * Renders nothing. Mount once, high in the tree, and above anything that
 * reads themed colours.
 */
export const ThemeManager = (): null => {
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.documentElement.classList.toggle('dark', resolvedTheme === 'dark');
  }, [resolvedTheme]);

  return null;
};
